export const storage = {
    useLocalStorage: true,
    useSessionStorage: true,

    data: {},

    setItem(key, value) {
        if (this.useLocalStorage) {
            try {
                return localStorage.setItem(key, value)
            } catch (e) {
                this.useLocalStorage = false
            }
        } else if (this.useSessionStorage) {
            try {
                return sessionStorage.setItem(key, value)
            } catch (e) {
                this.useSessionStorage = false
            }
        }

        this.data[key] = value
        return true
    },

    getItem(key) {
        if (this.useLocalStorage) {
            try {
                return localStorage.getItem(key)
            } catch (e) {
                this.useLocalStorage = false
            }
        } else if (this.useSessionStorage) {
            try {
                return sessionStorage.getItem(key)
            } catch (e) {
                this.useSessionStorage = false
            }
        }

        return this.data[key]
    },

    removeItem(key) {
        try {
            localStorage.removeItem(key)
        } catch (e) {
            // we don't care if it fails, we just want to make sure we unset from all storage engines
        }

        try {
            sessionStorage.removeItem(key)
        } catch (e) {
            // we don't care if it fails, we just want to make sure we unset from all storage engines
        }

        delete this.data[key]
    },
}



// WEBPACK FOOTER //
// ./app/utils.js